import { render, staticRenderFns } from "./RomanMeytin.vue?vue&type=template&id=69850e62&scoped=true&"
import script from "./RomanMeytin.vue?vue&type=script&lang=js&"
export * from "./RomanMeytin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69850e62",
  null
  
)

export default component.exports